import React from "react";

import { calculateFieldContributionStatus, useGetAllCarbonProgramOutcomes, useGetFarmReportingYear, useGetFarms, useTranslation } from "utils";

import { ENROLLMENT_TYPE } from "models";

import { Flex, Typography } from "components";

export const MissingDataGuidance = () => {
  const { t } = useTranslation("fieldTimeline");

  const { currentFarm } = useGetFarms();
  const carbonProgram = currentFarm?.carbonProgram ?? null;
  const { data: carbonProgramOutcomes, isLoading: isLoadingCarbonProgramOutcomes } = useGetAllCarbonProgramOutcomes(currentFarm?.id, carbonProgram);
  const {
    data: { activeFarmReportingYear },
    isLoading: isLoadingActiveReportingYear,
  } = useGetFarmReportingYear(currentFarm?.id || null);

  if (!activeFarmReportingYear || isLoadingActiveReportingYear || isLoadingCarbonProgramOutcomes) return null;

  const { fieldsContributingToPayouts, totalFields } = calculateFieldContributionStatus(carbonProgramOutcomes ?? {}, activeFarmReportingYear);
  const fieldsNotContributing = totalFields - fieldsContributingToPayouts;

  return (
    <Flex className="missing-data-guidance-container" vertical={true}>
      <Flex align="center">
        {fieldsNotContributing === 0 ? (
          <Typography variant="paragraph-m" data-testid="all-fields-contributing-text" className="missing-data-fields-text">
            {carbonProgram?.fieldsManagement?.fieldEnrollmentType === ENROLLMENT_TYPE.auto
              ? t("impactPanel.allFieldsContributing")
              : t("impactPanel.allEnrolledFieldsContributing")}
          </Typography>
        ) : (
          <Typography variant="paragraph-m" data-testid="fields-not-contributing-text" className="missing-data-fields-text">
            {t("impactPanel.fieldsNotContributing", { fieldsNotContributing, totalFields })}
          </Typography>
        )}
      </Flex>
    </Flex>
  );
};
